module.exports = __webpack_public_path__ + "static/john-craven-b0ff04e3ce8bb8d53faf112114ded778.png";